export const PAMM_STATUS_LABELS: Record<string, string> = {
  active: 'Active',
  inactive: 'Inactive',
  suspended: 'Suspended',
  closed: 'Closed',
  pending: 'Pending',
};

export const PAMM_FUND_STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'suspended', label: 'Suspended' },
  { value: 'closed', label: 'Closed' },
  { value: 'pending', label: 'Pending' },
];

export const PAMM_TRANSACTION_STATUS_OPTIONS = [
  { value: 'pending', label: 'Pending' },
  { value: 'approved', label: 'Approved' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'processing', label: 'Processing' },
  { value: 'completed', label: 'Completed' },
];

export const PAMM_REQUEST_STATUS_OPTIONS = [
  { value: 'pending', label: 'Pending' },
  { value: 'approved', label: 'Approved' },
  { value: 'rejected', label: 'Rejected' },
];

export const PAMM_TRADE_STATUS_OPTIONS = [
  { value: 'open', label: 'Open' },
  { value: 'closed', label: 'Closed' },
  { value: 'cancelled', label: 'Cancelled' },
];

export const PAMM_TRADE_DIRECTION_OPTIONS = [
  { value: 'buy', label: 'Buy' },
  { value: 'sell', label: 'Sell' },
];

export const PAMM_RISK_LEVEL_OPTIONS = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
];

export const PAMM_ALLOCATION_METHOD_OPTIONS = [
  { value: 'percentage', label: 'Percentage' },
  { value: 'lot_size', label: 'Lot Size' },
  { value: 'equity', label: 'Equity' },
];

export const PAMM_FEE_TYPE_OPTIONS = [
  { value: 'management', label: 'Management Fee' },
  { value: 'performance', label: 'Performance Fee' },
  { value: 'entry', label: 'Entry Fee' },
  { value: 'exit', label: 'Exit Fee' },
];

export const PAMM_REPORT_TYPE_OPTIONS = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
  { value: 'annual', label: 'Annual' },
  { value: 'custom', label: 'Custom' },
];

export const PAMM_LEVERAGE_OPTIONS = [
  { value: '1:10', label: '1:10' },
  { value: '1:50', label: '1:50' },
  { value: '1:100', label: '1:100' },
  { value: '1:200', label: '1:200' },
  { value: '1:500', label: '1:500' },
];

export const PAMM_CURRENCY_OPTIONS = [
  { value: 'USD', label: 'USD' },
  { value: 'EUR', label: 'EUR' },
  { value: 'GBP', label: 'GBP' },
];

export const PAMM_FUND_DETAILS_TABS = [
  { value: 'overview', label: 'Overview' },
  { value: 'investors', label: 'Investors' },
  { value: 'trades', label: 'Trades' },
  { value: 'performance', label: 'Performance' },
  { value: 'reports', label: 'Reports' },
  { value: 'history', label: 'History' },
  { value: 'settings', label: 'Settings' },
];

export const PAMM_INVESTOR_STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'suspended', label: 'Suspended' },
];

export const PAMM_AUDIT_ACTION_OPTIONS = [
  { value: 'create', label: 'Create' },
  { value: 'update', label: 'Update' },
  { value: 'delete', label: 'Delete' },
  { value: 'approve', label: 'Approve' },
  { value: 'reject', label: 'Reject' },
  { value: 'login', label: 'Login' },
  { value: 'export', label: 'Export' },
];

export const PAMM_NOTIFICATION_TYPE_OPTIONS = [
  { value: 'info', label: 'Info' },
  { value: 'success', label: 'Success' },
  { value: 'warning', label: 'Warning' },
  { value: 'error', label: 'Error' },
];

export const PAMM_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
export const PAMM_DEFAULT_PAGE_SIZE = 10;

export const PAMM_DATE_FORMAT = 'MMM dd, yyyy';
export const PAMM_DATETIME_FORMAT = 'MMM dd, yyyy HH:mm';

export const PAMM_TRADING_SYMBOLS = [
  'EUR/USD',
  'GBP/USD',
  'USD/JPY',
  'USD/CHF',
  'AUD/USD',
  'USD/CAD',
  'NZD/USD',
  'EUR/GBP',
  'EUR/JPY',
  'GBP/JPY',
  'XAU/USD',
  'WTI/USD',
];

export const PAMM_PAYMENT_METHODS = [
  { value: 'bank_transfer', label: 'Bank Transfer' },
  { value: 'credit_card', label: 'Credit Card' },
  { value: 'crypto', label: 'Cryptocurrency' },
  { value: 'ewallet', label: 'E-Wallet' },
];
